import { Action, createAction } from '@reduxjs/toolkit';
import { onError, onUpdateLoading } from '../system';
import {
  createArticle,
  deleteArticle,
  findArticleByCategory,
  findArticlesByQuery,
  findArticlesTemplateByCategory,
  updateArticle,
} from './article';
import {
  createUserCrm,
  deleteUserCrm,
  findUserCrmByQuery,
  updateUserCrm,
  changeUserCrmPassword,
} from './user-crm';
import { findArticleFields } from './articleField';
import {
  findGalleriesByQuery,
  findPhotosByIds,
  findPhotosByQuery,
  galleryCreate,
  galleryDelete,
  galleryUpdate,
  photoDelete,
} from './gallery';
import { findArticleCategories } from './article-category';
import {
  findVentureForMapById,
  findVentureBatchById,
  sendIntention,
  sendReservation,
  sendSimulation,
} from './venture';

export interface ApiError {
  message?: string | null;
  httpStatus?: string | null;
}

export enum CallbackType {
  // eslint-disable-next-line no-unused-vars
  ERROR,
  // eslint-disable-next-line no-unused-vars
  SUCCESS,
}

export interface Callback {
  type: CallbackType;
  full: boolean;
  function: Function;
}

function towParameterFunction(a: any): boolean {
  return a === true;
}

export type TwoParameterReturnBooleanFunctionType = typeof towParameterFunction;

function condition(
  callback: TwoParameterReturnBooleanFunctionType,
): TwoParameterReturnBooleanFunctionType {
  return callback;
}

function preProccess(expressionA: any): boolean {
  return expressionA;
}

export type BooleanFunctionType = typeof condition;
export type PreproccessFunctionType = typeof preProccess;

export interface ExtraAction {
  condition: TwoParameterReturnBooleanFunctionType;
  preProccess: PreproccessFunctionType | null;
  actionName: string;
  payload?: any;
}

export interface CustomError {
  code: number;
  message: string;
}

export interface ApiRequestPayload {
  url?: string;
  method?: string;
  data?: object;
  onSuccess?: string;
  onError?: string;
  onStart?: string;
  customErrors?: Array<CustomError>;
  extraActions?: Array<ExtraAction> | null;
  callbacks?: Array<Callback> | null | undefined;
  sessionKey?: string;
}

export interface ApiAction extends Action {
  payload: ApiRequestPayload;
}

export const apiCall = createAction<ApiRequestPayload>('api/call');

export const apiRequestDefaultPayload: ApiRequestPayload = {
  url: '',
  method: 'GET',
  onSuccess: 'string',
  onStart: onUpdateLoading.type,
  onError: onError.type,
};

export const createApiRequestPayload = (
  url: string,
  successActionName?: string,
  method: string = 'GET',
  data?: object,
  customErrorsMap = new Map<number, string>(),
  extraActions?: Array<ExtraAction> | null,
  callbacks?: Array<Callback> | null,
): ApiRequestPayload => {
  const customErrorList = Array.from(customErrorsMap, ([code, message]) => ({ code, message }));
  return {
    ...apiRequestDefaultPayload,
    url,
    method,
    data,
    onSuccess: successActionName,
    customErrors: customErrorList,
    extraActions,
    callbacks,
  };
};

const HttpClient = {
  findArticlesByQuery,
  findArticleByCategory,
  updateArticle,
  deleteArticle,
  findArticleFields,
  findArticlesTemplateByCategory,
  createArticle,
  galleryCreate,
  galleryUpdate,
  galleryDelete,
  photoDelete,
  findGalleriesByQuery,
  findPhotosByQuery,
  findPhotosByIds,
  findArticleCategories,
  createUserCrm,
  deleteUserCrm,
  findUserCrmByQuery,
  updateUserCrm,
  changeUserCrmPassword,
  findVentureForMapById,
  findVentureBatchById,
  sendIntention,
  sendReservation,
  sendSimulation,
};

export default HttpClient;
